import { parseDatePickerInputValue } from '@components/core-ui/form-elements/DatePicker/helpers/parseDatePickerInputValue';

export const parseDatePickerValue = (value: string | undefined, dateFormat = 'MM/dd/yyyy'): Date | null => {
  if (!value?.length) {
    return null;
  }

  if (value.includes('T') || /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const datePart = value.includes('T') ? value.split('T')[0] : value;
    const parts = datePart.split('-').map(Number);

    if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) {
      return null;
    }

    const [year, month, day] = parts;
    return new Date(year, month - 1, day);
  }

  return parseDatePickerInputValue(value, dateFormat);
};
